import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const Overview = Loader(lazy(() => import('src/content/overview')));

// General

const Home = Loader(lazy(() => import('src/content/general/home')));

// Applications

const Messenger = Loader(
  lazy(() => import('src/content/applications/Messenger'))
);
const Coaches = Loader(
  lazy(() => import('src/content/applications/Coaches'))
);
const Athletes = Loader(
  lazy(() => import('src/content/applications/Athletes'))
);
const Agencies = Loader(
  lazy(() => import('src/content/applications/Agencies'))
);
const AthleteProfileExample = Loader(
  lazy(() => import('src/content/applications/Users/athlete-profile'))
);

const CoachProfileExample = Loader(
  lazy(() => import('src/content/applications/Users/coach-profile'))
);

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Overview />
      },
      {
        path: 'overview',
        element: <Navigate to="/" replace />
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: '500',
            element: <Status500 />
          },
          {
            path: 'maintenance',
            element: <StatusMaintenance />
          },
          {
            path: 'coming-soon',
            element: <StatusComingSoon />
          }
        ]
      },
      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: 'general',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="home" replace />
      },
      {
        path: 'home',
        element: <Home />
      },
      {
        path: 'coaches',
        element: <Coaches />
      },
      {
        path: 'athletes',
        element: <Athletes />
      },
      {
        path: 'agencies',
        element: <Agencies />
      },
    ]
  },
  {
    path: 'communications',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="messenger" replace />
      },
      {
        path: 'messenger',
        element: <Messenger />
      }
    ]
  },
  {
    path: 'accounts',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="profile" replace />
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="athlete-details" replace />
          },
          {
            path: 'athlete-details',
            element: <AthleteProfileExample />
          },
          {
            path: 'coach-details',
            element: <CoachProfileExample />
          }
        ]
      }
    ]
  }
];

export default routes;
